import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'
import { api } from './api'
import * as actions from './actions'
import * as GateSelectors from 'app/modules/gates/selectors'
import { companyData } from './demodata'

const fetchDemandbaseCompanyData = (action$, { getState }) => {
  return action$
    .ofType(actions.fetchDemandbaseCompanyData.toString())
    .pluck('payload')
    .mergeMap(options => {
      if (GateSelectors.hasDemoOrg(getState())) {
        return companyData.map(data => actions.fetchDemandbaseCompanyDataSuccess({ data, ...options }))
      } else {
        return api
          .fetchDemandbaseCompanyData(options)
          .takeUntil(action$.ofType(actions.fetchDemandbaseCompanyDataCancelled()))
          .map(data => actions.fetchDemandbaseCompanyDataSuccess({ data, ...options }))
          .startWith(actions.fetchDemandbaseCompanyDataPending())
          .catch(error => Observable.of(actions.fetchDemandbaseCompanyDataFailed({ error, options })))
      }
    })
}

const fetchDemandbaseTargetingIndustries = (action$) => {
  return action$
    .ofType(actions.fetchDemandbaseTargetingIndustries.toString())
    .pluck('payload')
    .mergeMap(() => {
      return api.fetchDemandbaseIndustries()
        .map(response => actions.fetchDemandbaseTargetingIndustriesSuccess(response))
        .startWith(actions.fetchDemandbaseTargetingIndustriesPending())
        .catch(error => Observable.of(actions.fetchDemandbaseTargetingIndustriesFailed({ error })))
    })
}

const fetchDemandbaseTargetingSubIndustries = (action$) => {
  return action$
    .ofType(actions.fetchDemandbaseTargetingSubIndustries.toString())
    .pluck('payload')
    .mergeMap(() => {
      return api.fetchDemandbaseSubIndustries()
        .map(response => actions.fetchDemandbaseTargetingSubIndustriesSuccess(response))
        .startWith(actions.fetchDemandbaseTargetingSubIndustriesPending())
        .catch(error => Observable.of(actions.fetchDemandbaseTargetingSubIndustriesFailed({ error })))
    })
}

export const epic = combineEpics(fetchDemandbaseCompanyData, fetchDemandbaseTargetingIndustries, fetchDemandbaseTargetingSubIndustries)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/demandbase/epic.js